import HealaLogoIcon from "@/components/icons/heala-logo-icon";

export function HealaLoader() {
  // todo: use animated logo icon
  return <HealaLogoIcon className="animate-pulse" />;
}

export function HealaFillLogoLoader() {
  return (
    <div className="flex justify-center items-center h-full w-full">
      <HealaLoader />
    </div>
  );
}
